import Arrow from "@/common/icons/arrow"
import Block from "@/components/wrappers/block"
import styles from "@/blocks/theme/link-list/link-list.module.css"

export default function LinkList({ block }) {
  const { attrs } = block

  if (attrs.links.length === 0) {
    return null
  }

  const items = attrs.links.map((item, key) => {
    if (item.url === null) {
      return null
    }

    const meta = [
      typeof item.type === "string" ? item.type.toUpperCase() : "",
      item.size
    ]

    return (
      <li key={key} className="flex mb-8">
        <div className="w-8 mr-3">
          <div
            className={`flex items-center justify-center w-8 h-8 ${styles.iconWrapper}`}>
            <Arrow className="w-4" />
          </div>
        </div>
        <div className="justify-between flex-grow">
          <a
            href={item.url}
            target="_blank"
            rel="noreferrer"
            className="leading-8 underline">
            {item.title}
          </a>
          <span className="pl-2">({meta.filter(Boolean).join(", ")})</span>
        </div>
      </li>
    )
  })

  return (
    <Block
      block={block}
      width="column"
      className={`box-content px-4 mx-auto sm:px-10 max-w-1xl ${styles.linkList}`}>
      <ul>{items}</ul>
    </Block>
  )
}
